var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResult = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 24.7C11.2375 25.2 10.3 25.0625 9.8 24.4C9.3 23.7375 9.38125 22.8 10.1 22.3L10.9 21.7C13.2375 19.95 16.0812 19 19 19H21.5C22.3312 19 23 19.6688 23 20.5C23 21.3312 22.3312 22 21.5 22H19C16.7313 22 14.5188 22.7375 12.7 24.1L11.9 24.7ZM13.025 13C13.025 14.1062 12.125 15 11.025 15C9.91875 15 9.025 14.1062 9.025 13C9.025 11.8938 9.91875 11 11.025 11C12.125 11 13.025 11.8938 13.025 13ZM19.025 13C19.025 11.8938 19.9187 11 21.025 11C22.125 11 23.025 11.8938 23.025 13C23.025 14.1062 22.125 15 21.025 15C19.9187 15 19.025 14.1062 19.025 13ZM32 16C32 24.8375 24.8375 32 16 32C7.1625 32 0 24.8375 0 16C0 7.1625 7.1625 0 16 0C24.8375 0 32 7.1625 32 16ZM16 3C8.81875 3 3 8.81875 3 16C3 23.1812 8.81875 29 16 29C23.1812 29 29 23.1812 29 16C29 8.81875 23.1812 3 16 3Z",
    fill: "#952809"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResult);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NoResult.d3c8b423ab07c9e13135469c7c12e609.svg";